import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSetState } from '@domain-group/react-hooks'

import { digObject } from '@domain-group/javascript-utils'

import { Button } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useFlipperKey from '@hooks/useFlipperKey'
import useInvoice from '@hooks/useInvoice'

const defaultState = {
  updating: false,
}
interface ApproveInvoiceButtonProps {
  invoiceId: number,
}

const ApproveInvoiceButton = (props: ApproveInvoiceButtonProps) => {
  const { invoiceId } = props

  // We can't use the updating value from the useInvoice hook because
  // Updating is true for every row in the table when one row is updating
  const [state, setState] = useSetState(defaultState)
  const { updating } = state

  const invoicePayload = useInvoice({ id: invoiceId })
  const {
    callbacks: {
      approveInvoice: approveFn,
      handleCallbackActionWithConfirmation,
    }, invoice,
  } = invoicePayload

  const approved: boolean = digObject(invoice, 'approved', '')
  const isVoid: boolean = digObject(invoice, 'void', '')

  const approveInvoicePayload = {
    callbacks: {
      actionFn: approveFn,
      afterAction: () => setState({ updating: false }),
      afterError: () => setState({ updating: false }),
      beforeAction: () => setState({ updating: true }),
    },
    strings: {
      actionString: 'approve',
    },
  }

  const { isProviderUser } = useCurrentUser()
  const canViewApproveButton = !!isProviderUser

  if (!canViewApproveButton) return null

  return (
    <Button
      buttonStyle="secondaryCreate"
      disabled={approved || isVoid}
      loading={updating}
      icon={<FontAwesomeIcon icon={faCheck} />}
      onClick={() => {
        // @ts-expect-error TS2345
        handleCallbackActionWithConfirmation(approveInvoicePayload)
      }}
      size="medium"
    >
      {approved ? 'Approved' : 'Approve'}
    </Button>
  )
}

export default ApproveInvoiceButton
